<template lang="pug">
  .content
    .content__block.content-things
      h3.camp-content__subtitle Как собрать ребенка в лагерь?
      ul
        li(
        v-for="item in things.split(';')"
        )
          p.camp-content__text {{item}}
</template>

<script>

export default {
  name: "CampThings",
  props: {
    things: {
      type: String,
      default: ""
    }
  }

};
</script>
